import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {EnlistComponent} from "./enlist/enlist.component";

const routes: Routes = [
    { path: 'enlist', component: EnlistComponent, outlet: 'modal'},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MailchimpRoutingModule { }
